import type { FC } from "react";
import { useFormContext } from "react-hook-form";
import type { ConnectionCategory } from "../../../moment/hooks/use-connections";
import type { MomentFormMoment } from "../../../moment/types/moment-form-moment";
import { DynamicCCForm } from "../dynamic-cc-form";
import { SegmentForm } from "../segment-form";
import type { ToFormProps } from "./types";

export const EmployeeForm: FC<
  ToFormProps & {
    showEditCC: boolean;
    showViewCC: boolean;
    connectionCategories: ConnectionCategory[];
  }
> = ({
  formDisabled,
  continueClicked,
  showEditCC,
  showViewCC,
  connectionCategories,
  restrictedSegments,
}) => {
  const {
    formState: { submitCount },
  } = useFormContext<MomentFormMoment>();

  return (
    <>
      <SegmentForm
        disabled={formDisabled}
        showValidationErrors={continueClicked || submitCount > 0}
        connectionCategories={connectionCategories}
        restrictedSegments={restrictedSegments}
        segmentLabel="In segment"
        segmentPlaceholder="In segment"
      />
      {(showEditCC || showViewCC) && <DynamicCCForm disabled={formDisabled} />}
    </>
  );
};
